<!-- Contenedor botones navegación -->
<div class="p-grid p-m-0 p-jc-center p-ai-center p-px-4 p-px-md-3 p-pt-3 bg-gris">
  <div class="p-col-12 p-sm-10 p-md-12 p-lg-10 p-xl-8 p-offset-0 p-xl-offset-1">
    <div class="p-d-flex p-flex-column p-flex-md-row">
      <button 
        pButton 
        type="button" 
        icon="pi pi-angle-left" 
        label="Volver al inicio" 
        routerLink="/"
        class="p-mr-2 p-mb-2 btn-primary-outline">
      </button>
      <button 
        pButton 
        type="button" 
        icon="pi pi-angle-left" 
        label="Volver atrás" 
        routerLink="/curso-detalle"
        [queryParams]="{ curso_id: curso_id, version: version, codigoAcceso: codigoAcceso }"
        class="p-mr-2 p-mb-2 btn-primary-outline">
      </button>
    </div>
  </div>
</div>
<!-- Fin botones navegación -->

<!-- Contenedor información postulaciones -->
<div #infoPanel class="p-grid p-m-0 p-jc-center p-ai-center bg-gris">
  <div class="p-col-12 p-sm-10 p-md-6 p-lg-5 p-xl-4 p-px-4 p-px-md-3 p-pb-5 p-pb-md-6">
    <h1>Registro y postulación</h1>
    <p>Está a punto de postular al curso. Proporcione sus datos a
      continuación para crear y habilitar su cuenta. Recuerde revisar que su correo electrónico se encuentre
      correctamente escrito, ya que toda información será enviada al correo proporcionado.
    </p>
  </div>
  <div class="p-col-12 p-sm-10 p-md-6 p-lg-5 p-xl-3 p-text-right p-px-4 p-px-md-3 p-pb-5 p-pb-md-6">
    <img width="100%" src="assets/images/registro_postulacion.svg" />
  </div>
</div>
<!-- Fin información postulaciones -->

<!-- Formulario postulación -->
<div class="p-grid p-m-0 p-jc-center bg-gris-oscuro" style="position: relative;">
  <div class="p-col-12 p-sm-10 p-md-12 p-lg-10 p-xl-7 p-offset-0 p-offset-xl-1 p-px-4 p-px-md-3 p-py-5 p-py-md-6">
    <h1>Proporcione sus datos a continuación</h1>
    <form [formGroup]="form">
      <p-card>
        <div class="p-grid">
          
          <!-- SECCIÓN INFORMACIÓN PERSONAL -->
          <div class="p-col-12 p-md-12 p-lg-12">
            <div class="p-grid p-fluid">

              <div class="p-col-12 p-d-flex p-ai-center">
                <i class="pi pi-user p-mr-3" style="font-size: 2rem"></i>
                <h4><b>Información personal</b></h4>
              </div>
              
              <div class="p-col-12 p-d-flex p-ai-center p-ml-2">
                <span class="p-mb-2 p-mr-2">Soy extranjero:</span>
                <p-inputSwitch [disabled]="form.disabled" (onChange)="setExtranjero($event)"></p-inputSwitch>
              </div>
              
              <!-- RUT -->
              <div *ngIf="!extranjero" class="p-col-12 p-md-6 p-lg-12 p-xl-6">
                <span class="p-float-label">
                  <input type="text" id="inputtext" [maxLength]="10" (change)="comprobarRutExistente()" (keypress)="regExpInput('^[0-9kK\-]',$event)"
                    pInputText formControlName="run">
                  <label for="inputtext">Run <small>(Ej: 12345678-9)</small></label>
                </span>
                <div *ngIf="form.get('run').invalid && (form.get('run').dirty || form.get('run').touched)">
                  <span class="p-error" *ngIf="form.get('run').hasError('required')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe ingresar su Run.</small>
                  </span>
                  <span class="p-error" *ngIf="form.get('run').hasError('minlength')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Ingrese un Run válido.</small>
                  </span>
                  <span class="p-error" *ngIf="form.get('run').errors?.invalidRun">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">El Run ingresado no es válido.</small>
                  </span>
                  <span class="p-error" *ngIf="form.get('run').hasError('maxlength')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Límite de caracteres excedido.</small>
                  </span>
                  <span class="p-error" *ngIf="form.get('run').hasError('existe')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">El run ya se encuentra registrado.</small>
                  </span>
                </div>
              </div>

              <!-- NUMERO PASAPORTE postulante, si se habilita a extranjeros -->
              <div *ngIf="extranjero" class="p-col-12 p-md-6 p-lg-12 p-xl-6">
                <span class="p-float-label">
                  <input type="text"  [maxLength]="50" (keypress)="regExpInput('^[a-zA-Z0-9]',$event)"  (change)="comprobarPasaporteExistente()" pInputText formControlName="nroPasaporte">
                  <label for="inputtext">Nro. Identificación <small>(DNI/Pasaporte/Otro)</small></label>
                </span>
                <div *ngIf="form.get('nroPasaporte').invalid && (form.get('nroPasaporte').dirty || form.get('nroPasaporte').touched)">
                  <span class="p-error" *ngIf="form.get('nroPasaporte').hasError('required')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe ingresar su pasaporte.</small>
                  </span>
                  <span class="p-error" *ngIf="form.get('nroPasaporte').hasError('minlength')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Ingrese un pasaporte válido.</small>
                  </span>
                  <span class="p-error" *ngIf="form.get('nroPasaporte').hasError('maxlength')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Límite de caracteres excedido.</small>
                  </span>
                  <span class="p-error" *ngIf="form.get('nroPasaporte').hasError('existe')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">El nro. de pasaporte ya se encuentra registrado.</small>
                  </span>
                </div>
              </div>

              <!-- PASAPORTE postulante, si se habilita a extranjeros -->
              <div *ngIf="extranjero" class="p-col-12 p-md-6 p-lg-12 p-xl-6">
                <p-fileUpload
                  #fileUpload
                  accept=".pdf,.jpg,.jpeg,.png"
                  chooseIcon="pi pi-paperclip"
                  [chooseLabel]="form.get('pasaporte').valid ? 'Seleccionar otro documento' : 'Adjuntar identificación pdf o imagen'"
                  [customUpload]="true"
                  [showUploadButton]="false"
                  [showCancelButton]="false"
                  (onSelect)="uploadFile($event)"
                  [disabled]="form.disabled"
                >
                <ng-template pTemplate="file">
                </ng-template>
                </p-fileUpload>
                <div *ngIf="form.get('pasaporte').valid" class="p-mt-3 p-mb-2 p-pl-2">
                  <span (mouseenter)="previewImage.show($event)" (mouseleave)="previewImage.hide()">
                    <small>
                      <i class="pi p-mr-2" [ngClass]="fileExtension == 'pdf' ? 'pi-file-pdf' : 'pi-image'"></i>{{archivoSel.name}} | 
                      <i class="pi pi-save p-mr-2"></i> {{this.fileUtils.getSizeInMegaBytes(archivoSel) |  number: '1.2-2'}}MB</small>
                  </span>
                  <p-overlayPanel [appendTo]="infoPanel" #previewImage hideTransitionOptions="0s linear">
                    <ng-template *ngIf="fileExtension == 'png' || fileExtension == 'jpg' || fileExtension == 'jpeg' " pTemplate>
                        <img width="100%" [src]="archivoSel_base64">
                    </ng-template>
                    <ng-template *ngIf="fileExtension == 'pdf' " pTemplate>
                      <span>Vista previa no disponible.</span>
                    </ng-template>
                </p-overlayPanel>
                </div>
                <div *ngIf="form.get('pasaporte').invalid && (form.get('pasaporte').touched || submitted)" class="p-mt-3">
                  <span class="p-error" *ngIf="form.get('pasaporte').hasError('required')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe adjuntar la imagen de su pasaporte.</small>
                  </span>
                </div>
                <div *ngIf="form.get('pasaporte').invalid" class="p-mt-3">
                  <span class="p-error" *ngIf="form.get('pasaporte').hasError('fileExtension')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Archivo no válido, solo PDF e imágenes (JPG y PNG).</small>
                  </span>
                  <span class="p-error" *ngIf="form.get('pasaporte').hasError('maxFileSize')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Archivo muy grande, máximo {{MAX_FILE_SIZE}}MB.</small>
                  </span>
                </div>
              </div>

              <!-- NOMBRES -->
              <div class="p-col-12 p-md-6 p-lg-12 p-xl-6">
                <span class="p-float-label">
                  <input type="text" pInputText [maxLength]="35" formControlName="nombres">
                  <label>Nombres</label>
                </span>
                <div *ngIf="form.get('nombres').invalid && (form.get('nombres').dirty || form.get('nombres').touched)">
                  <span class="p-error" *ngIf="form.get('nombres').hasError('required')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe ingresar su nombre.</small>
                  </span>
                  <span class="p-error" *ngIf="form.get('nombres').hasError('minlength')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Ingrese un nombre válido.</small>
                  </span>
                  <span class="p-error" *ngIf="form.get('nombres').hasError('maxlength')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Límite de caracteres excedido.</small>
                  </span>
                </div>
              </div>

              <!-- APELLIDO PATERNO -->
              <div class="p-col-12 p-md-6 p-lg-12 p-xl-6">
                <span class="p-float-label">
                  <input type="text" id="inputtext" [maxLength]="25" pInputText formControlName="paterno">
                  <label for="inputtext">Apellido paterno</label>
                </span>
                <div *ngIf="form.get('paterno').invalid && (form.get('paterno').dirty || form.get('paterno').touched)">
                  <span class="p-error" *ngIf="form.get('paterno').hasError('required')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe ingresar su apellido
                      paterno.</small>
                  </span>
                  <span class="p-error" *ngIf="form.get('paterno').hasError('minlength')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Ingrese un apellido válido.</small>
                  </span>
                  <span class="p-error" *ngIf="form.get('paterno').hasError('maxlength')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Límite de caracteres excedido.</small>
                  </span>
                </div>
              </div>

              <!-- APELLIDO MATERNO -->
              <div class="p-col-12 p-md-6 p-lg-12 p-xl-6">
                <span class="p-float-label">
                  <input type="text" id="inputtext" [maxLength]="25" pInputText formControlName="materno">
                  <label *ngIf="extranjero" for="inputtext">Apellido materno (opcional)</label>
                  <label *ngIf="!extranjero" for="inputtext">Apellido materno</label>
                </span>
                <div *ngIf="form.get('materno').invalid && (form.get('materno').dirty || form.get('materno').touched)">
                  <span class="p-error" *ngIf="form.get('materno').hasError('required')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe ingresar su apellido
                      materno.</small>
                  </span>
                  <span class="p-error" *ngIf="form.get('materno').hasError('minlength')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Ingrese un apellido válido.</small>
                  </span>
                  <span class="p-error" *ngIf="form.get('materno').hasError('maxlength')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Límite de caracteres excedido.</small>
                  </span>
                </div>
              </div>

              <!-- SEXO -->
              <div class="p-col-12 p-md-6 p-lg-12 p-xl-6">
                <span class="p-float-label">
                  <p-dropdown appendTo="body" [autoDisplayFirst]="false" [options]="sexos" formControlName="id_sexo"
                    optionLabel="label" optionValue="value"></p-dropdown>
                  <label for="inputtext">Sexo</label>
                </span>
                <div *ngIf="form.get('id_sexo').invalid && (form.get('id_sexo').dirty || form.get('id_sexo').touched)">
                  <span class="p-error" *ngIf="form.get('id_sexo').hasError('required')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe seleccionar su sexo</small>
                  </span>
                </div>
              </div>

              <!-- FECHA NACIMIENTO -->
              <div class="p-col-12 p-md-6 p-lg-12 p-xl-6">
                <span class="p-float-label">
                  <p-calendar firstDayOfWeek="1" dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                    yearRange="1900:2100" [maxDate]="fechaRestriccion" [defaultDate]="fechaRestriccion"
                    [readonlyInput]="true" formControlName="fechaNacimiento"></p-calendar>
                  <label>Fecha nacimiento</label>
                </span>
                <div *ngIf="form.get('fechaNacimiento').invalid && (form.get('fechaNacimiento').dirty || form.get('fechaNacimiento').touched)">
                  <span class="p-error" *ngIf="form.get('fechaNacimiento').hasError('required')">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe ingresar su fecha de
                      nacimiento</small>
                  </span>
                  <span class="p-error" *ngIf="form.get('fechaNacimiento').errors?.minimumAgeRequired">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debes ser mayor de 18 años para
                      postular.</small>
                  </span>
                  <span class="p-error" *ngIf="form.get('fechaNacimiento').errors?.dateError">
                    <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe ingresar una fecha
                      válida.</small>
                  </span>
                </div>
              </div>

            </div>
          </div>
          <!-- FIN SECCIÓN INFORMACIÓN PERSONAL -->

          <!-- SECCIÓN INFORMACIÓN CONTACTO -->
          <div class="p-col-12 p-md-12 p-lg-12">
            <div class="p-card-background">
              <div class="p-card-alternative">
                <div class="p-grid p-fluid">
                  <div class="p-col-12 p-d-flex p-ai-center">
                    <i class="pi pi-id-card p-mr-3" style="font-size: 2rem"></i>
                    <h4><b>Información de contacto</b></h4>
                  </div>
                  
                  <!-- CORREO ELECTRÓNICO -->
                  <div class="p-col-12 p-md-6 p-lg-12 p-xl-6" formGroupName="correos">
                    <span class="p-float-label">
                      <input type="text" id="inputtext" [maxLength]="100" (change)="comprobarCorreoExistente()" pInputText formControlName="correo">
                      <label for="inputtext">Correo electrónico</label>
                    </span>
                    <div *ngIf="form.get(['correos','correo']).invalid && (form.get(['correos','correo']).dirty || form.get(['correos','correo']).touched)">
                      <span class="p-error" *ngIf="form.get(['correos','correo']).hasError('required')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe ingresar su correo</small>
                      </span>
                      <span class="p-error" *ngIf="form.get(['correos','correo']).hasError('maxlength')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Límite de caracteres excedido.</small>
                      </span>
                      <span class="p-error" *ngIf="form.get(['correos','correo']).hasError('pattern')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Ingrese un correo válido.</small>
                      </span>
                      <span class="p-error" *ngIf="form.get(['correos','correo']).hasError('existe')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">El correo ingresado ya se encuentra registrado.</small>
                      </span>
                    </div>
                  </div>

                  <!-- REPETIR CORREO ELECTRÓNICO -->
                  <div class="p-col-12 p-md-6 p-lg-12 p-xl-6" formGroupName="correos">
                    <span class="p-float-label">
                      <input type="text" id="inputtext" [maxLength]="100" pInputText formControlName="reCorreo">
                      <label for="inputtext">Repita correo electrónico</label>
                    </span>
                    <div *ngIf="form.get(['correos','reCorreo']).invalid && (form.get(['correos','reCorreo']).dirty || form.get(['correos','reCorreo']).touched)">
                      <span class="p-error" *ngIf="form.get(['correos','reCorreo']).hasError('required')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe ingresar nuevamente su correo.</small>
                      </span>
                      <span class="p-error" *ngIf="form.get(['correos','reCorreo']).value !== '' && form.get(['correos','reCorreo']).hasError('mismatch')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Los correos no coinciden.</small>
                      </span>
                    </div>
                  </div>

                  <!-- CELULAR -->
                  <div  *ngIf="!extranjero" class="p-col-12 p-md-6 p-lg-12 p-xl-6">
                    <span class="p-float-label">
                      <input type="text" digitOnly id="inputtext" [maxLength]="9"
                        (keypress)="regExpInput('^([0-9])',$event)" pInputText formControlName="telefono">
                      <label for="inputtext">Celular <small>(opcional)</small></label>
                    </span>
                    <div *ngIf="form.get('telefono').invalid && (form.get('telefono').dirty || form.get('telefono').touched)">
                      <span class="p-error" *ngIf="form.get('telefono').hasError('maxlength')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Límite de caracteres excedido.</small>
                      </span>
                      <span class="p-error" *ngIf="form.get('telefono').hasError('minlength')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">El número debe contener los 9 dígitos.</small>
                      </span>
                      <span class="p-error" *ngIf="form.get('telefono').hasError('pattern') && (form.get('telefono').value.length <= 9)">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe ingresar solo números.</small>
                      </span>
                    </div>
                  </div>

                  <!-- REGIÓN -->
                  <div *ngIf="!extranjero" class="p-col-12 p-md-6 p-lg-12 p-xl-6">
                    <span class="p-float-label">
                      <p-dropdown 
                        appendTo="body" 
                        [autoDisplayFirst]="false" 
                        [options]="regiones" 
                        formControlName="id_region" 
                        optionLabel="label" 
                        optionValue="value"
                        (onChange)="cargarComunas()">
                      </p-dropdown>
                      <label for="inputtext">Región</label>
                    </span>
                    <div *ngIf="form.get('id_region').invalid && (form.get('id_region').dirty || form.get('id_region').touched)">
                      <span class="p-error" *ngIf="form.get('id_region').hasError('required')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe seleccionar su región.</small>
                      </span>
                    </div>
                  </div>

                  <!-- COMUNA -->
                  <div *ngIf="!extranjero" class="p-col-12 p-md-6 p-lg-12 p-xl-6">
                    <span class="p-float-label">
                      <p-dropdown 
                        appendTo="body" 
                        [autoDisplayFirst]="false" 
                        [options]="comunas"
                        formControlName="id_comuna" 
                        optionLabel="label" 
                        optionValue="value"
                        emptyMessage="Seleccione región...">
                      </p-dropdown>
                      <label for="inputtext">Comuna</label>
                    </span>
                    <div *ngIf="form.get('id_region').valid && form.get('id_comuna').invalid && (form.get('id_comuna').dirty || form.get('id_comuna').touched)">
                      <span class="p-error" *ngIf="form.get('id_comuna').hasError('required')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe seleccionar su comuna.</small>
                      </span>
                    </div>
                  </div>

                  <!-- PAÍS -->
                  <div *ngIf="extranjero" class="p-col-12 p-md-6 p-lg-12 p-xl-6">
                    <span class="p-float-label">
                      <p-dropdown 
                        appendTo="body" 
                        [autoDisplayFirst]="false" 
                        [options]="paises"
                        formControlName="id_pais" 
                        [filter]="true"
                        optionLabel="label" 
                        optionValue="value">
                      </p-dropdown>
                      <label for="inputtext">País</label>
                    </span>
                    <div *ngIf="form.get('id_pais').invalid && (form.get('id_pais').dirty || form.get('id_pais').touched)">
                      <span class="p-error" *ngIf="form.get('id_pais').hasError('required')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe seleccionar su país de origen.</small>
                      </span>
                    </div>
                  </div>

                  <!-- DIRECCIÓN -->
                  <div  *ngIf="!extranjero" class="p-col-12 p-md-6 p-lg-12 p-xl-6">
                    <span class="p-float-label">
                      <input type="text" id="inputtext" [maxLength]="100" pInputText formControlName="direccion">
                      <label for="inputtext">Dirección <small>(opcional)</small></label>
                    </span>
                    <div *ngIf="form.get('direccion').invalid && (form.get('direccion').dirty || form.get('direccion').touched)">
                      <span class="p-error" *ngIf="form.get('direccion').hasError('maxlength')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Límite de caracteres excedido.</small>
                      </span>
                    </div>
                  </div>

                  <!-- EXALUMNO -->
                  <div class="p-col-12 p-md-6 p-lg-12 p-xl-6 opcion">
                    <span class="p-float-label">
                      <p-dropdown 
                        appendTo="body" 
                        [autoDisplayFirst]="false" 
                        [options]="exalumno"
                        formControlName="exalumno" 
                        optionLabel="label" 
                        optionValue="value">
                      </p-dropdown>
                      <label for="inputtext">Exalumno</label>
                    </span>
                    <div *ngIf="form.get('exalumno').invalid && (form.get('exalumno').dirty || form.get('exalumno').touched)">
                      <span class="p-error" *ngIf="form.get('exalumno').hasError('required')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Indique si ha sido o no alumno de la UV.</small>
                      </span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <!-- FIN SECCIÓN INFORMACIÓN CONTACTO -->

          <!-- SECCIÓN INFORMACIÓN ADICIONAL -->
          <div class="p-col-12 p-md-12 p-lg-12">
            <div class="p-card-background">
              <div class="p-card-alternative">
                <div class="p-grid p-fluid">
                  <div class="p-col-12 p-d-flex p-ai-center">
                    <i class="pi pi-info-circle p-mr-3" style="font-size: 2rem"></i>
                    <h4><b>Información adicional</b></h4>
                  </div>
                  
                  <!-- NIVEL ESTUDIOS -->
                  <div class="p-col-12 p-md-6 p-lg-12 p-xl-6">
                    <span class="p-float-label">
                      <p-dropdown 
                        appendTo="body" 
                        [autoDisplayFirst]="false" 
                        [options]="nivelesEducacion" 
                        formControlName="id_nivel_estudios" 
                        optionLabel="label" 
                        [tooltipDisabled]="!extranjero"
                        pTooltip="Selecciona el nivel más alto y representativo de acuerdo a los niveles existentes en tu país"
                        optionValue="value">
                      </p-dropdown>
                      <label for="inputtext">Nivel de estudio completado</label>
                    </span>
                    <div *ngIf="form.get('id_nivel_estudios').invalid && (form.get('id_nivel_estudios').dirty || form.get('id_nivel_estudios').touched)">
                      <span class="p-error" *ngIf="form.get('id_nivel_estudios').hasError('required')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe seleccionar su nivel de estudios.</small>
                      </span>
                    </div>
                  </div>

                  <!-- OCUPACIÓN -->
                  <div class="p-col-12 p-md-6 p-lg-12 p-xl-6">
                    <span class="p-float-label">
                      <input type="text" id="inputtext" [maxLength]="50" pInputText formControlName="ocupacion">
                      <label for="inputtext">Ocupación o profesión</label>
                    </span>
                    <div *ngIf="form.get('ocupacion').invalid && (form.get('ocupacion').dirty || form.get('ocupacion').touched)">
                      <span class="p-error" *ngIf="form.get('ocupacion').hasError('required')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Debe indicar su ocupación o profesión.</small>
                      </span>
                      <span class="p-error" *ngIf="form.get('ocupacion').hasError('minlength')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Ingrese una ocupación válida.</small>
                      </span>
                      <span class="p-error" *ngIf="form.get('ocupacion').hasError('maxlength')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Límite de caracteres excedido.</small>
                      </span>
                    </div>
                  </div>

                  <!-- EMPRESA -->
                  <div class="p-col-12 p-md-6 p-lg-12 p-xl-6">
                    <span class="p-float-label">
                      <input type="text" id="inputtext" [maxLength]="50" pInputText formControlName="empresa">
                      <label for="inputtext">Empresa u organización <small>(opcional)</small></label>
                    </span>
                    <div *ngIf="form.get('empresa').invalid && (form.get('empresa').dirty || form.get('empresa').touched)">
                      <span class="p-error" *ngIf="form.get('empresa').hasError('minlength')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Ingrese el nombre completo.</small>
                      </span>
                      <span class="p-error" *ngIf="form.get('empresa').hasError('maxlength')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Límite de caracteres excedido.</small>
                      </span>
                    </div>
                  </div>

                  <!-- MEDIO DISUFIÓN -->
                  <div class="p-col-12 p-md-6 p-lg-12 p-xl-6">
                    <span class="p-float-label">
                      <p-dropdown 
                        appendTo="body" 
                        [autoDisplayFirst]="false" 
                        [options]="preguntasPostulacion" 
                        formControlName="preguntaCurso" 
                        optionLabel="label" 
                        optionValue="value">
                      </p-dropdown>
                      <label for="inputtext">¿Cómo conociste el curso? </label>
                    </span>
                    <div *ngIf="form.get('preguntaCurso').invalid && (form.get('preguntaCurso').dirty || form.get('preguntaCurso').touched)">
                      <span class="p-error" *ngIf="form.get('preguntaCurso').hasError('required')">
                        <i class="pi pi-exclamation-circle"></i><small class="p-ml-1">Cuéntanos como llegaste a este curso.</small>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- FIN SECCIÓN INFORMACIÓN ADICIONAL -->

          <div *ngIf="submitted && form.invalid" class="p-col-12">
            <p-message severity="warn" text="Asegúrese de completar los datos requeridos antes de postular."></p-message>
          </div>
          <div *ngIf="response.hasOwnProperty('status')" class="p-col-12">
            <p-message [severity]="response.status === 'ERROR' ? 'warn' : 'success'" [text]="response.data"></p-message>
          </div>
        </div>
      </p-card>
      <div class="p-col-12 p-sm-12 p-md-9 p-lg-12 p-xl-12 p-mt-4 p-d-flex">
        <p>
          <small class="text-primary">
            Al enviar tus datos, estás aceptando los términos y condiciones dispuestos por 
            la Universidad de Valparaíso. No se realizará cobro alguno a menos que se indique de 
            forma explícita.
          </small>
        </p>
      </div>
      <div class="p-col-12 p-sm-12 p-md-9 p-lg-12 p-xl-12 p-mt-4 p-d-flex">  
        <button 
          *ngIf="!postula"
          pButton 
          type="button" 
          (click)="onSubmit()" 
          icon="pi pi-check-circle"
          [disabled]="loading" 
          [loading]="loading"
          [label]="loading ? 'Postulando, espere...' : 'Postular ahora'" 
          class="btn-default-outline">
        </button>
        <button *ngIf="postula" routerLink="/login" icon="pi pi-sign-in" pButton label="Ir al inicio de sesión" class="btn-secondary"></button>
      </div>
    </form>
  </div>

  <!-- WAVE FORM -->
  <div class="p-col-12 p-p-0 p-m-0 wave" style="position: absolute; bottom: 0px;">
    <div class="p-m-0" style="bottom: 0 !important">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path fill="#232c70" fill-opacity="1"
            d="M0,0L80,5.3C160,11,320,21,480,58.7C640,96,800,160,960,176C1120,192,1280,160,1360,144L1440,128L1440,
            320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z">
          </path>
        </svg>
    </div>
    <div class="p-m-0 wave-bg" style="background-color: #232c70; margin-top: -15px !important;">
    </div>
  </div>
</div>